/**
 * 图片URL白名单验证工具
 * 用于验证图片URL是否在允许的域名列表中
 */

// 白名单域名列表
const WHITELIST_DOMAINS = [
  'syntrust.inside.h2os.cloud:7000',
  'dev.service.syntrust.inside.h2os.cloud:7000',
  'synnovator.com'
];

/**
 * 验证URL是否在白名单中
 * @param {string} url - 要验证的URL
 * @returns {boolean} - 是否在白名单中
 */
export const isUrlInWhitelist = (url) => {
  if (!url) return false;
  
  try {
    const urlObj = new URL(url);
    const host = urlObj.host; // 包含端口号
    const hostname = urlObj.hostname; // 不包含端口号
    
    return WHITELIST_DOMAINS.some(domain => {
      // 精确匹配域名（包含端口号）
      if (domain.includes(':')) {
        return host === domain;
      }
      // 匹配域名（不包含端口号）
      // 支持域名及其所有子路径
      return host === domain || 
             hostname === domain || 
             host.startsWith(domain + ':') ||
             hostname.endsWith('.' + domain);
    });
  } catch (error) {
    console.warn('Invalid URL format:', url);
    return false;
  }
};

/**
 * 获取白名单域名列表
 * @returns {string[]} - 白名单域名列表
 */
export const getWhitelistDomains = () => {
  return [...WHITELIST_DOMAINS];
};

/**
 * 添加域名到白名单
 * @param {string} domain - 要添加的域名
 */
export const addDomainToWhitelist = (domain) => {
  if (domain && !WHITELIST_DOMAINS.includes(domain)) {
    WHITELIST_DOMAINS.push(domain);
  }
};

/**
 * 从白名单中移除域名
 * @param {string} domain - 要移除的域名
 */
export const removeDomainFromWhitelist = (domain) => {
  const index = WHITELIST_DOMAINS.indexOf(domain);
  if (index > -1) {
    WHITELIST_DOMAINS.splice(index, 1);
  }
};
